import './ColorInput.css';

import { ChangeEvent } from 'react';
import type { GridInputBaseProps } from '../../types';
import { normalizeHex } from './utils/normalizeHex';

type ColorInputProps = Pick<
  GridInputBaseProps<string | null>,
  'onChange' | 'onTouch' | 'disabled' | 'name'
> & {
  // Hex color; the API always returns it with the leading #.
  value: string | null;
};

// Native color picker for control type 'color' (QA-264). The palette keys the
// API sends alongside (`palletName`, `palette`) are deliberately ignored —
// agreed in QA-264. Emits #RRGGBB (the API output format).
const ColorInput = ({
  value,
  name,
  disabled,
  onChange,
  onTouch,
}: ColorInputProps) => {
  const normalizedValue = normalizeHex(value);

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const nextValue = `#${normalizeHex(event.target.value)}`;
    onChange(nextValue);
    onTouch?.(nextValue);
  };

  return (
    // .input-container matches the vertical padding of the standard inputs, so
    // the swatch lines up with a string input in the same row.
    <label
      className={`form-input color-input input-container${
        disabled ? ' color-input-disabled' : ''
      }`}
    >
      <input
        type="color"
        name={name}
        value={normalizedValue ? `#${normalizedValue}` : '#000000'}
        disabled={disabled}
        onChange={handleChange}
      />
      <span className="color-input-value">
        {normalizedValue ? `#${normalizedValue}` : ''}
      </span>
    </label>
  );
};

export default ColorInput;
